import React from 'react'

const WarningIcon = () => {
  return (
    <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5 2.5C5.275 2.5 5.5 2.725 5.5 3V5C5.5 5.275 5.275 5.5 5 5.5C4.725 5.5 4.5 5.275 4.5 5V3C4.5 2.725 4.725 2.5 5 2.5ZM4.995 0C2.235 0 0 2.24 0 5C0 7.76 2.235 10 4.995 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 4.995 0ZM5 9C2.79 9 1 7.21 1 5C1 2.79 2.79 1 5 1C7.21 1 9 2.79 9 5C9 7.21 7.21 9 5 9ZM5.5 7.5H4.5V6.5H5.5V7.5Z'
        fill='#402080'
      />
    </svg>
  )
}

export default WarningIcon
